// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"69529db53dcf880f6e73","453":"57b0a2b7c2266356397c","577":"e7e349a706b446ca740e"}[chunkId] + ".js";
};